/**
 * Skill Packs (niche) API Service — v2
 *
 * A pack groups skills for a niche and carries a demo profile_template. Used by
 * the onboarding niche selector and to adapt the app to the chosen vertical.
 * See ARCHITECTURE.md / VISION.md (pack = unit of distribution & monetization).
 */
import type { components } from './schema.gen';
import apiClient from './client';

type Schemas = components['schemas'];

export type Pack = Schemas['Pack'];
export type PackSummary = Schemas['PackSummary'];
export type PackProfileTemplate = Schemas['PackProfileTemplate'];

export const packsAPI = {
  list: async (): Promise<PackSummary[]> => {
    const response = await apiClient.get<PackSummary[]>('/packs');
    return response.data;
  },

  get: async (id: string): Promise<Pack> => {
    const response = await apiClient.get<Pack>(`/packs/${id}`);
    return response.data;
  },
};
